export default defineNuxtRouteMiddleware((to, from) => {
  const isLogin = to.meta.name === "Login";
  const isPrivacyPolicy = to.meta.name === "PrivacyPolicy";
  const isProtected = getStateValue("protected");

  if (!isProtected) {
    return;
  }

  if (isProtected && !isLogin && !isPrivacyPolicy) {
    return navigateTo("/accedi");
  }
});
